//react imports
import * as React from 'react';

//components
import LeadImage from '../components/LeadImage.jsx';

//images
import safety from '../assets/img/sections/public-safety.jpeg';

const PublicSafety = () => {
  return (
    <section className="section" id="publicsafety">
      <div className="wrapper" id="publicsafety-wrapper">
        <LeadImage
          image={safety}
          text={
            'A biker roams the streets of College Park. (Photo by Tom Hausman/The Diamondback)'
          }
        />

        <h1>PUBLIC SAFETY</h1>
        <h3 className="first-line">
          In an effort to connect the university and the city, the committee
          aims for College Park to not only be ranked among the safest college
          towns in the country, but also be perceived as such.
        </h3>
        <p>
          Since university President Wallace Loh’s arrival in 2010, crime has
          gone down significantly. Reports of burglaries and motor vehicle
          thefts have dropped nearly 75 percent, and robberies, assaults and
          violent crimes have remained scarce, according to University Police
          data.
          <br />
          <br />
          But Loh said many people don’t realize that fact, given the frequency
          of University Police alerts sent to the community.
        </p>

        <h3 className="list-heading">Accomplisments To Date</h3>

        <p className="p-heading">
          Expanded UMD Student Code of Conduct throughout the City
        </p>
        <p className="descrip">
          According to Andrea Goodwin, director of the Office of Student
          Conduct, the number of off-campus complaints involving students has
          roughly doubled since 2013, when the code expanded. Most of these
          complaints are resolved quickly and generally entail noise violations,
          disorderly conduct or drug and alcohol abuse, she said. The expansion
          has clarified the reporting process and helps students avoid contact
          with local law enforcement, she added.
          <br /> <br />
          “Instead of students having to potentially stand in criminal court,
          it’s now being handled by the university,” Goodwin said. “It’s a
          blurred line between city and campus, and we’d rather work with our
          students and help them learn from their mistakes, rather than
          punishing them.”
          <br /> <br />
          Goodwin, who is also a member of the partnership’s public safety
          committee, said sanctions typically include an educational penalty or
          a discussion about how the behavior affects the community, and once
          the complaint is resolved “we usually never see them again.”
          <br />
          <br />
          “For most, it is their first and last violation,” she said.
        </p>

        <p className="p-heading">
          Expanded University Police jurisdiction to more of the city
        </p>
        <p className="descrip">
          Eric Olson, the partnership’s executive director, said the police
          expansion brought them into areas where more students live, primarily
          in the downtown and Old Town areas but also as far up as Route 193 and
          Greenbelt. This was to enhance police presence in the midtown, Berwyn,
          Lakeland and Calvert Hills neighborhoods, which led to the hiring of
          five more officers.
          <br /> <br />
          Loh said increasing police presence was a major priority of his from
          the start. When the city did not agree to subsidize new hires, Loh
          decided the university would pay for them if they were given broader
          jurisdiction.
          <br /> <br />
          “And over the past seven years, crime in College Park has steadily
          going down,” Loh said. “The numbers are there.”
          <br /> <br />
          With many Greek life members renting houses in Old Town, Anthony
          Busani, president of the university’s Interfraternity Council, said he
          and other board members have been meeting with city officials to
          “build better relationships” and “improve accountability on both
          ends.”
          <br /> <br />
          But the rising senior marketing and supply chain management major said
          while he thinks opening lines of communication will be mutually
          beneficial in the long run, he thinks the city wastes police resources
          by enforcing some “ridiculous” code violations on students.
        </p>

        <p className="p-heading">Implemented public safety cameras</p>
        <p className="descrip">
          According to a study by the Police Foundation, a nonprofit aiming to
          improve policing, College Park has installed more than 50 security
          cameras using city funds, as well as grant money. The cameras — which
          Olson said have been installed “over a number of years” — are located
          in the city parking garages, along the Trolley Trail and in Old Town,
          Calvert Hills and Lakeland.
          <br /> <br />
          He added that while University Police have access to all the cameras,
          they are not all actively monitored. The Police Foundation assessment
          further found that “requests for review averaged about 450 per year
          with usable video becoming available about half the time and an
          average of approximately 27 arrests per year.”
          <br /> <br />
          Olson said they plan to adjust the camera plan based on the results of
          the study.
        </p>

        <p className="p-heading">Implemented County Nuisance Board</p>
        <p className="descrip">
          Olson helped pass legislation to enact the board during his time on
          the county council, although the legislation was put into effect after
          he departed the job in 2014. He said it helps to regulate matters of
          “particularly egregious damages to home properties” such as “renting
          out housing without the permits.”
          <br /> <br />
          The board can also revoke rental licenses and distribute fines.
          <br /> <br />
          Olson said he did not have information on how many complaints the
          board has adjudicated.
        </p>

        <p className="p-heading">
          Launched and completed a public safety ambassador pilot program
        </p>
        <p className="descrip">
          University Police managed and trained the ambassadors, a mix of both
          students and non-students, who received an hourly wage from the
          university for their nighttime patrol service, Olson said. The
          partnership helped secure grant money for the program’s first year.
          <br /> <br />
          The ambassadors served as “eyes and ears” for the community, Olson
          said, walking around in police jurisdiction areas with radios. They
          not only patrolled, but also provided people with directions and
          escorts, he added.
          <br /> <br />
          The program’s funding ran out after the first year. Olson said the
          partnership was not able to provide additional funding, but said the
          police could choose to renew the program on its own. He also said the
          student police auxiliary serve a similar purpose.
          <br /> <br />
          The Police Foundation lauded the program in its 2018 assessment of
          College Park.
        </p>

        <p className="p-heading">
          Awarded and completed Crime Prevention Through Environmental Design
          analysis of the Trolley Trail
        </p>
        <p className="descrip">
          A program provided by the U.S. Justice Department recommends
          strategies for crime deterrence via assessments of environmental
          design. With the five-mile Trolley Trail connecting Hyattsville and
          College Park through a clear pedestrian route, Olson said they wanted
          to have it assessed so once opened, it could be used as much as
          possible.
          <br /> <br />
          Last year, the Virginia Center for Policing Innovation carried out a
          study of the trail, using CPTED analysis. The study measured
          overgrowth, visibility and illumination, among other factors.
          <br /> <br />
          Recommendations for improvement included adding more cameras and
          lighting, cutting back overgrowth and applying general maintenance to
          “the commercial area of Hyattsville.”
          <br /> <br />
          Olson said each municipality will address lighting with their
          individual budgets. He added that he’s hopeful they can use grant
          money to place additional cameras on the Trolley Trail this year.
        </p>

        <h3 className="list-heading">
          Highlights of the Public Safety 2018 Work Plan
        </h3>

        <p className="p-heading">
          Review city’s public safety and police services study
        </p>
        <p className="descrip">
          Long-term recommendations from the Police Foundation include creating
          a standalone police department for College Park to “allow for more
          flexible and more responsive staffing allocation decisions,” as well
          as a real-time crime-monitoring and data collection center.
          <br /> <br />
          The study supported funding additional live camera monitoring services
          and encouraged contracting or combining resources with another local
          police agency, though it acknowledged these suggestions may not be
          feasible.
        </p>

        <p className="p-heading">Review and support city camera plan</p>
        <p className="descrip">
          The Police Foundation assessment states: “Determining where the crime
          hotspots are, re-installing cameras in those areas, and increasing the
          number of usable videos that lead to identifying and arresting
          suspects is an attainable goal for College Park. Longer term, as
          innovation continues to expand available options and reduce prices,
          the City should either partner with other local agencies or the Prince
          George’s County Office of Information Technology to establish a
          real-time crime center where cameras can be monitored and viewers can
          dispatch law enforcement to crimes as they are occuring.”
        </p>

        <p className="p-heading">Public safety ambassador pilot program</p>
        <p className="descrip">
          University spokesperson Jessica Jennings could not confirm whether
          there are plans to extend the ambassador program, although she noted
          that University Police “supplemented the end of this program with
          additional Student Police Auxiliary.”
          <br /> <br />
          A study carried out in 2017 by the Virginia Center for Policing
          Innovation urged the city to “explore opportunities to keep the Safety
          Ambassador Program functional and funded.” It continues, “if funding
          cannot be secured, an alternative option might be to implement it as a
          police cadet program for students in the Administration of Justice
          program at the University, or to recruit local community members who
          are interested in providing volunteer services.”
        </p>
      </div>
    </section>
  );
};

export default PublicSafety;



// WEBPACK FOOTER //
// ./src/views/PublicSafety.jsx